import { env } from "@/environment";
import { observable } from "mobx";

type WorkflowState = "active" | "built_in" | "built_in/editable";

type CatalogManagerRolePermission = "finance_reports_access" |
    "completion_reports_access" |
    "permission_control_access";

export interface CanvasRole {
    label: string;
    canvas_id: number;
    catalog_manager_role_id?: number;
}

export interface PermissionOption {
    label: string;
    value: CatalogManagerRolePermission;
}

export class CatalogManagerRole {
    @observable id: number;
    @observable name: string;
    @observable workflow_state: WorkflowState;
    @observable permissions: PermissionOption[];
    @observable canvas_role: CanvasRole;

    constructor(data: any) {
        Object.assign(this, data);
    }

    isEditable(userCmRoles?: CatalogManagerRole[]): boolean {
        if (userCmRoles && userCmRoles.some(role => role.id === this.id)) {
            return false;
        }
        return this.workflow_state == "active" || this.workflow_state == "built_in/editable";
    }

    isDeletable(userCmRoles?: CatalogManagerRole[]): boolean {
        if (userCmRoles && userCmRoles.some(role => role.id === this.id)) {
            return false;
        }
        return this.workflow_state != "built_in" && this.workflow_state != "built_in/editable";
    }

    get payload() {
        const payload = {
            name: this.name,
            workflow_state: this.workflow_state,
            permissions: this.permissions.map(perm => perm.value)
        }
        if (this.canvas_role.canvas_id > 0 ) {
            payload.canvas_role_id = this.canvas_role.canvas_id;
        }
        return payload;
    }

    grants(permission: CatalogManagerRolePermission): boolean {
        return this.permissions.some(perm => perm.value === permission);
    }
}
